













import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    nickname: {
      type: String,
      default: 'Anon',
    },
    summary: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    averageRating: {
      type: Number,
      required: true,
    },
    createdAt: {
      type: Date,
    },
  },
});
